<template>
  <span>
    <!-- <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading> -->
    <v-app id="inspire" class="mt-5">
      <v-main>
        <v-alert v-if="error" :value="true" color="error">
          {{ error }}
        </v-alert>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm6 md7>
              <!-- Ширина ограничена намеренно: поля регистрации короткие
                   (почта, имя, город), и на широком экране строка ввода в
                   полтора экрана читается плохо — глазу неоткуда начать.
                   640px — примерно та же мера, что у карточки на лендинге. -->
              <v-card class="elevation-12 mx-auto" style="max-width: 640px" :loading="isLoading">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>{{
                    $t("users.registration")
                  }}</v-toolbar-title>
                </v-toolbar>
                <!-- FT-097 PR-D: трёхшаговый визард, зеркало лендинга.
                     Шаг 1 — почта, шаг 2 — код и учётные данные, шаг 3 — бизнес.
                     Порядок и состав шагов намеренно совпадают с лендингом:
                     человек, начавший регистрацию там и продолживший здесь,
                     не должен заново разбираться в форме. -->
                <v-stepper v-model="step" flat class="elevation-0 signup-stepper">
                  <v-stepper-header class="elevation-0">
                    <v-stepper-step :complete="step > 1" step="1" :editable="step > 1">
                      {{ $t("users.step_account") }}
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="step > 2" step="2" :editable="step > 2">
                      {{ $t("users.step_confirm") }}
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="3">{{ $t("users.step_business") }}</v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items>
                    <!-- Шаг 1: только почта -->
                    <v-stepper-content step="1">
                      <v-text-field v-model.trim="email" data-cy="email" label="Email" autocomplete="email" required
                        :disabled="emailFieldDisabled" :error-messages="stepError"
                        @input="stepError = ''"></v-text-field>
                      <v-flex class="text-right">
                        <v-btn color="primary" data-cy="next-step" :loading="sendingCode" @click="nextStep()">
                          {{ $t("users.next_step") }}
                        </v-btn>
                      </v-flex>
                    </v-stepper-content>

                    <!-- Шаг 2: код из письма + имя и пароль -->
                    <v-stepper-content step="2">
                <v-flex class="mb-3">
                    <v-btn v-if="verificationStep === 'idle'" outlined color="primary"
                      :block="$vuetify.breakpoint.smAndDown"
                      :loading="sendingCode" :disabled="!email || sendingCode"
                      @click="requestVerificationCode()">
                      {{ $t('users.get_code') }}
                    </v-btn>
                    <template v-else-if="verificationStep === 'sent'">
                      <p class="text-body-2 text--secondary mb-2">
                        {{ $t('users.code_sent_to') }} <strong>{{ email }}</strong>
                      </p>
                      <v-text-field v-model.trim="verificationCode" data-cy="code" :label="$t('users.enter_code')"
                        autocomplete="one-time-code" :error="!!verificationError"
                        :error-messages="verificationError"
                        @input="verificationError = ''"></v-text-field>
                      <!-- Три кнопки одного размера: раньше «подтвердить» была
                           обычной, а две другие small — разная высота в одном
                           ряду читалась как случайность. Иерархия задаётся не
                           размером, а видом: основное действие залито, два
                           вспомогательных — текстовые. -->
                      <div class="d-flex flex-wrap align-center mb-2" style="gap: 8px">
                        <v-btn small depressed color="primary"
                          :block="$vuetify.breakpoint.xsOnly"
                          :loading="verifyingCode"
                          :disabled="!verificationCode || verifyingCode" @click="verifyCode()">
                          {{ $t('users.confirm_code') }}
                        </v-btn>
                        <v-btn small text
                          :block="$vuetify.breakpoint.xsOnly"
                          :loading="sendingCode"
                          :disabled="resendCooldown > 0 || sendingCode" @click="requestVerificationCode()">
                          <span v-if="resendCooldown > 0">{{ $t('users.resend_in_seconds', { n: resendCooldown }) }}</span>
                          <span v-else>{{ $t('users.resend_code') }}</span>
                        </v-btn>
                        <v-btn small text :block="$vuetify.breakpoint.xsOnly"
                          @click="changeEmail()">{{ $t('users.change_email') }}</v-btn>
                      </div>
                    </template>
                    <template v-else-if="verificationStep === 'verified'">
                      <v-alert dense text type="success" class="mb-2">{{ $t('users.email_verified') }}</v-alert>
                      <v-btn small text @click="changeEmail()">{{ $t('users.change_email') }}</v-btn>
                    </template>
                  </v-flex>
                      <v-text-field v-model.trim="user_name" data-cy="user_name" :label="req('users.your_name')"
                        :placeholder="$t('users.your_name_placeholder')" autocomplete="off" required></v-text-field>
                      <v-text-field v-model.trim="password" data-cy="password"
                        :append-icon="show1 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                        :type="show1 ? 'text' : 'password'" name="password" autocomplete="new-password"
                        :hint="$t('users.password_length')" persistent-hint @click:append="show1 = !show1"
                        :label="req('users.password_most')" required></v-text-field>
                      <v-text-field v-model.trim="password_confirmation" data-cy="password_confirmation"
                        :append-icon="show1 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                        :type="show1 ? 'text' : 'password'" name="password_confirmation" autocomplete="new-password"
                        @click:append="show1 = !show1"
                        :label="req('users.password_repeat')" required></v-text-field>
                      <v-alert v-if="stepError" dense text type="error" class="mb-2">{{ stepError }}</v-alert>
                      <v-flex class="d-flex justify-space-between">
                        <v-btn text @click="prevStep()">{{ $t("users.back_step") }}</v-btn>
                        <v-btn color="primary" data-cy="next-step" @click="nextStep()">{{ $t("users.next_step") }}</v-btn>
                      </v-flex>
                    </v-stepper-content>

                    <!-- Шаг 3: бизнес-данные -->
                    <v-stepper-content step="3">
                      <v-text-field v-model.trim="company_name" data-cy="company_name" :label="req('users.company_name')"
                        :placeholder="$t('users.company_name_placeholder')" autocomplete="off" required></v-text-field>
                      <v-autocomplete :label="$t('rental_objects.rental_object')" v-model="rental_object"
                        :items="rental_objects" item-text="text" item-value="value" auto-select-first>
                      </v-autocomplete>
                      <v-autocomplete :label="$t('users.country')" data-cy="country" v-model="country" :items="countries"
                        @change="phoneCode()" :item-text="locale == 'ru' ? 'russian' : 'both'" item-value="name"
                        auto-select-first return-object :filter="customCountryFilter">
                      </v-autocomplete>
                      <!-- FT-097 REQ-10: телефон составной — код страны отдельно
                           от номера. Ключ опции — ISO страны, а НЕ сам код:
                           тринадцать кодов делятся между странами (+7 — Россия
                           и Абхазия, +1 — США, Канада и ещё несколько), и при
                           ключе-коде выбор «+7» снапался на первую попавшуюся
                           строку. На лендинге на этом уже обожглись. -->
                      <v-row dense>
                        <v-col cols="5" sm="4">
                          <v-autocomplete v-model="phone_country" :items="phoneCountries" item-text="text"
                            item-value="value" :label="$t('users.phone_code')" auto-select-first
                            @change="phoneCodeTouched = true"></v-autocomplete>
                        </v-col>
                        <v-col cols="7" sm="8">
                          <v-text-field v-model.trim="phone_national" data-cy="phone_national" :label="req('users.phone')"
                            :placeholder="$t('users.phone_national_placeholder')" inputmode="tel"
                            :error="phone_error" :error-messages="phone_error_text"
                            @input="phone_error = false, phone_error_text = ''"></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Город и часовой пояс — на виду, а не в свёрнутом блоке:
                           по городу геокодируется компания (api: Company#geocoded_by :city),
                           а неверная зона портит рабочее время проката с первого дня.
                           Ровно та же правка, что сделана на лендинге. -->
                      <v-text-field v-model.trim="city" data-cy="city" :label="req('users.city')"
                        :placeholder="$t('users.city_placeholder')" required></v-text-field>
                      <v-autocomplete v-model="time_zone" item-text="text" item-value="value" :items="time_zones"
                        :label="$t('users.time_zone')"
                        :placeholder="$t('users.time_zone_placeholder')"></v-autocomplete>
                      <v-autocomplete v-model="locale" item-text="text" item-value="value" :items="locales"
                        :label="$t('companies.locale')"
                        :placeholder="$t('companies.locale_plc')"></v-autocomplete>
                  <v-checkbox v-model="createDemo" :label="$t('users.create_demo')"></v-checkbox>
                  <v-divider></v-divider>
                  <v-flex class="d-flex" align-center>
                    <v-checkbox v-model="agreement" data-cy="agreement">
                      <template v-slot:label>
                        <v-flex>
                          {{ $t("users.i_agree") }}
                          <a :href="`https://rentprog.${locale == 'ru' ? 'ru' : 'com'
                            }/${$root.$i18n.locale}/agreement`" class="subtitle-2" target="_blank">{{
                              $t("users.agreement_space") }}</a>
                          {{ $t("users.i_agree_3") }}
                          <a :href="`https://rentprog.${locale == 'ru' ? 'ru' : 'com'
                            }/${$root.$i18n.locale}/privacy`" class="subtitle-2" target="_blank">{{
                              $t("users.i_agree_2") }}</a>
                        </v-flex>
                      </template>
                    </v-checkbox>
                  </v-flex>
                      <v-alert v-if="stepError" dense text type="error" class="mb-2">{{ stepError }}</v-alert>
                      <v-flex class="d-flex justify-space-between align-center">
                        <v-btn text @click="prevStep()">{{ $t("users.back_step") }}</v-btn>
                        <v-btn @click="signup()" data-cy="submit" color="success" :loading="isLoading" :disabled="!canSubmit">{{
                          $t("users.registrations")
                        }}</v-btn>
                      </v-flex>
                      <div class="mt-4 text-center">
                        <router-link to="/signin">{{ $t("users.enter") }}</router-link>
                        <br />
                        <router-link to="/forgot_password">{{ $t("users.password_lost") }}</router-link>
                      </div>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-overlay :value="showCreateDemo">
          <v-card>
            <v-card-text>
              {{ $t("custom.create_demo_content") }}
              <v-progress-linear class="mt-2" color="info accent-4" indeterminate rounded
                height="6"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-overlay>
      </v-main>
    </v-app>
  </span>
</template>

<script>
import { countries } from "./countries";
import { buildTimeZoneOptions } from "@/helpers/timezones";
import { detectTimezone } from "@/helpers/geoPrefill";
import { Capacitor } from "@capacitor/core";
import Cookies from "js-cookie";
export default {
  name: "Signup",
  data() {
    return {
      // FT-097 PR-D: текущий шаг визарда и текст ошибки текущего шага.
      // Ошибка одна на шаг, а не на поле: полей мало, а сплошной список
      // подсказок под каждым — то, от чего мы в этой фиче и уходим.
      step: 1,
      stepError: "",
      user_name: null,
      phone: null,
      // FT-097 REQ-10: видимые части составного телефона. `phone` остаётся
      // тем, что уходит на сервер, — контракт POST /users не меняется.
      phone_country: null,
      phone_national: null,
      // Код, выбранный руками, не перетирается сменой страны компании:
      // у человека может быть российский номер при португальской фирме.
      phoneCodeTouched: false,
      phone_error: false,
      phone_error_text: "",
      company_name: null,
      countries: [],
      country: null,
      city: null,
      email: null,
      // FT-095: под-флоу подтверждения email кодом перед сабмитом.
      // idle -> sent -> verified; "изменить email" сбрасывает обратно в idle.
      verificationStep: "idle",
      verificationCode: null,
      verificationToken: null,
      verificationError: "",
      sendingCode: false,
      verifyingCode: false,
      resendCooldown: 0,
      resendTimerId: null,
      password: null,
      password_confirmation: null,
      rental_objects: [
        { text: this.$t("rental_objects.cars"), value: "cars" },
        { text: this.$t("rental_objects.bicycles"), value: "bicycles" },
        { text: this.$t("rental_objects.motorcycles"), value: "motorcycles" },
        { text: this.$t("rental_objects.taxies"), value: "taxies" },
        { text: this.$t("rental_objects.boats"), value: "boats" },
        { text: this.$t("rental_objects.construction_machinery"), value: "construction_machinery" },
        { text: this.$t("rental_objects.equipment"), value: "equipment" },
        { text: this.$t("rental_objects.airplanes"), value: "airplanes" },
        { text: this.$t("rental_objects.trucks"), value: "trucks" },
        { text: this.$t("rental_objects.trailers"), value: "trailers" },
        { text: this.$t("rental_objects.caravans"), value: "caravans" },
        { text: this.$t("rental_objects.other"), value: "other" },
      ],
      rental_object: "cars",
      time_zones: buildTimeZoneOptions(),
      time_zone:
        this.$root.$i18n.locale == "ru" ? "Europe/Moscow" : "Europe/Lisbon",
      locales: [
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      locale: this.$root.$i18n.locale,
      createDemo: true,
      showCreateDemo: false,
      show1: false,
      agreement: false,
      isLoading: false,
      error: "",
    };
  },
  computed: {
    // FT-095: гейт сабмита — UI-шаг подтверждения email обязателен всегда,
    // независимо от того, включена ли server-side проверка (флаг
    // enforcement сейчас OFF, см. комментарий у verification_token в
    // signup()). Единый UX: кнопка активна только после verified.
    canSubmit() {
      return this.verificationStep === "verified";
    },
    // FT-095: email редактируем только пока под-флоу не начат И пока не в
    // полёте первый запрос кода (иначе можно поменять email после отправки
    // кода на другой адрес).
    emailFieldDisabled() {
      return this.verificationStep !== "idle" || this.sendingCode;
    },
    // FT-097 REQ-10: опции селекта кода. value — ISO страны, а не сам код:
    // коды не уникальны, и ключ-код снапал бы выбор на чужую строку.
    phoneCountries() {
      return this.countries
        .filter((c) => c.phone && c.phone[0])
        .map((c) => ({
          value: c.code,
          text: `${c.flag || ""} +${c.phone[0]}`.trim(),
        }));
    },
  },
  created() {
    // this.checkSignedIn();
    if (this.$i18n && this.$i18n.locale && this.$i18n.locale == "ru") {
      this.countries = countries;
    } else {
      this.countries = countries.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (this.$route.query.ref) {
      localStorage.setItem("referral_code", this.$route.query.ref);
    }
    this.prefillFromBrowser();
  },
  updated() {
    // this.checkSignedIn();
  },
  beforeDestroy() {
    this.clearResendCooldown();
  },
  watch: {
    locale() {
      this.$i18n.locale = this.locale;
      this.$root.$i18n.locale = this.locale;
      localStorage.setItem("lang", this.locale);
    },
    // FT-097 REQ-10: обе видимые части телефона склеиваются в `phone`.
    // Без этого номер уезжал бы пустым — ровно тот баг, который на лендинге
    // поймали только мутационным тестом.
    phone_country() {
      this.syncPhone();
    },
    phone_national() {
      this.syncPhone();
    },
  },
  methods: {
    // ───── FT-097 PR-D: навигация по шагам ─────
    //
    // Валидация шага, а не всей формы: человек не должен видеть претензии к
    // полям, до которых ещё не дошёл. Состав шагов зеркалит лендинг
    // (STEP_FIELDS в signup_controller.js), чтобы обе поверхности вели себя
    // одинаково.
    validateStep(step) {
      if (step === 1) {
        if (!this.email) return this.$t("users.email_required");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) return this.$t("users.email_invalid");
        return "";
      }
      if (step === 2) {
        // Гейт подтверждения тот же, что и у кнопки сабмита: без verified
        // дальше не пускаем — код уже отправлен, вводить его больше негде.
        if (this.verificationStep !== "verified") return this.$t("users.confirm_email_first");
        if (!this.user_name) return this.$t("users.name_required");
        if (!this.password) return this.$t("users.password_required");
        if (this.password !== this.password_confirmation) return this.$t("users.passwords_mismatch");
        return "";
      }
      // FT-120: шаг 3 раньше не валидировался — незаполненное поле упиралось в общий
      // снекбар «заполните все поля», без указания, какое именно. Пока страна
      // предзаполнялась браузером, это почти не всплывало; теперь пустая страна —
      // состояние по умолчанию, а от неё зависят валюта, провайдер и тариф, так что
      // ошибка обязана называть поле.
      if (step === 3) {
        if (!this.company_name) return this.$t("users.company_name_required");
        if (!this.country) return this.$t("users.country_required");
        if (!this.city) return this.$t("users.city_required");
        return "";
      }
      return "";
    },

    async nextStep() {
      const error = this.validateStep(this.step);
      if (error) {
        this.stepError = error;
        return;
      }
      this.stepError = "";
      // Уходя с первого шага, запрашиваем код — чтобы к моменту показа поля
      // ввода письмо уже было в пути. Та же механика, что на лендинге.
      if (this.step === 1 && this.verificationStep === "idle") {
        await this.requestVerificationCode();
        // Проверяем ИТОГ, а не факт вызова: при 429/422 под-флоу остаётся в
        // 'idle', и листать шаг нельзя — человек окажется на шаге
        // подтверждения без кода и с кнопкой «получить код». Ветку
        // «429 cooldown» это пропускает: там код уже в пути, шаг = 'sent'.
        if (this.verificationStep === "idle") return;
      }
      if (this.step < 3) this.step += 1;
    },

    prevStep() {
      this.stepError = "";
      if (this.step > 1) this.step -= 1;
    },

    // Метка без звёздочки. На каждом шаге визарда обязательны ВСЕ поля, и
    // звёздочка у каждого перестаёт различать — остаётся шум. Снимаем здесь,
    // а не в переводах: те же ключи используют форма филиалов и сброс пароля,
    // где поля смешаны и звёздочка как раз работает.
    req(key) {
      return this.$t(key).replace(/\s*\*\s*$/, "");
    },

    // FT-097 REQ-03: часовой пояс из браузера, а не из локали страницы. Дефолт по
    // языку врал: русскоязычный из Португалии получал Europe/Moscow — ровно та же
    // ошибка, что чинилась на лендинге. Подставляем только то, чего пользователь ещё
    // не трогал, и только если значение есть в наших справочниках.
    //
    // FT-120: страну здесь БОЛЬШЕ НЕ ПОДСТАВЛЯЕМ. Поле стало денежным — api считает от
    // него валюту, платёжного провайдера и тариф, а IP оставил фолбэком. Догадка
    // браузера заявлением пользователя не является: русская локаль или московская
    // зона у человека из Германии молча выбрали бы ему рубли и Tinkoff, причём под
    // видом «клиент сам указал». Пустое поле честнее: либо пользователь выберет
    // страну сам, либо зону определит IP.
    prefillFromBrowser() {
      const tz = detectTimezone();
      if (tz && this.time_zones.some((o) => o.value === tz)) {
        this.time_zone = tz;
      }
    },

    selectSource(source) {
      // ['Неопределено', 'SEO', 'Контекст', 'Instagram', 'Telegram', 'Facebook', 'VseProkaty', 'VK', 'Whatsapp']
      switch (source) {
        // case 'seo':
        //   return 'SEO';
        //   break;
        case 'context':
          return 'Контекст';
        case 'instagram':
          return 'Instagram';
        case 'tg':
          return 'Telegram';
        case 'fb':
          return 'Facebook';
        case 'vp':
          return 'VseProkaty';
        case 'vk':
          return 'VK';
        case 'wa':
          return 'Whatsapp';
        case 'email':
          return 'Email';
        case 'crmindex':
          return 'CrmIndex';
        case 'picktech':
          return 'Picktech';
        case 'a2is':
          return 'A2is';
        case 'chat':
          return 'Chat';
        case 'phone':
          return 'Обзвон';
        default:
          return 'Партнерская программа';
      }
    },
    signup() {
      let self = this;
      // FT-120: кнопка submit — единственный выход с шага 3, и validateStep её раньше не
      // видел (он звался только из nextStep). Без этой строки адресная ошибка была
      // недостижима из интерфейса: человек получал общий снекбар «заполните все поля»
      // ровно там, где от поля страны зависят валюта, провайдер и тариф.
      const stepThreeError = this.validateStep(3);
      if (stepThreeError) {
        this.stepError = stepThreeError;
        return;
      }
      if (
        this.email &&
        this.password &&
        this.password_confirmation &&
        this.password === this.password_confirmation &&
        this.user_name &&
        this.rental_object &&
        this.company_name &&
        (this.phone && this.phone.length > 5) &&
        this.country &&
        this.city &&
        this.agreement
      ) {
        this.isLoading = true;
        let data = {
          user: {
            name: this.user_name,
            phone: this.phone,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
            encrypted_password_digest: this.password,
          },
          company_name: this.company_name,
          rental_object: this.rental_object,
          country: this.country.name,
          currency_code: this.country.currency[0],
          city: this.city,
          time_zone: this.time_zone,
          locale: this.locale,
          // Нет ref (в нативное приложение кука с ref не попадает) — фиксируем
          // платформу регистрации: web | ios | android (формат Capacitor.getPlatform()).
          source: localStorage.getItem('referral_code') ? this.selectSource(localStorage.getItem('referral_code')) : Capacitor.getPlatform(),
          referral_code: localStorage.getItem('referral_code') ? localStorage.getItem('referral_code') : null,
          create_demo: this.createDemo,
          // FT-095: сервер-флаг верификации сейчас OFF — шлём token всегда, когда
          // он есть (undefined-ключ axios/JSON.stringify отбрасывает), отсутствие
          // подтверждения регистрацию не блокирует.
          verification_token: this.verificationToken || undefined,
        };
        this.axios({
          url: "users",
          baseURL: this.$store.getters.getApiUrl, // FT-018
          method: "post",
          data: data,
        })
          .then((response) => {
            const token = response.data && response.data.handoff_token;
            if (!token) {
              // FM-06: аккаунт создан, но тикета нет — регистрацию НЕ повторяем,
              // ведём ко входу с подставленным email.
              this.isLoading = false;
              this.$router.push({ path: "/signin", query: { email: this.email } }).catch(() => {});
              return null;
            }
            return this.axios({
              url: "api/v1/auth/handoff",
              baseURL: this.$store.getters.getApiUrl,
              method: "post",
              data: { handoff_token: token },
            })
              .then((res) => {
                this.$store.commit("setUserInfo", res);
                this.$store.commit("setUserSettings", res.data.user_settings);
                Cookies.set("auth_token", res.headers.authorization, { expires: 365 });
                this.getUserInfo();
              })
              .catch(() => {
                // Изолированный catch: ошибка обмена НЕ должна всплыть в общий
                // обработчик регистрации и показать «email уже занят».
                this.isLoading = false;
                this.$router.push({ path: "/signin", query: { email: this.email } }).catch(() => {});
              });
          })
          .catch((error) => {
            this.isLoading = false;
            const serverError = error.response && error.response.data && error.response.data.error;
            if (serverError === "email_not_verified") {
              // FT-095: сервер отклонил verification_token (протух/невалиден
              // между verifyCode() и сабмитом) — это НЕ «email уже занят»,
              // маппить в user_exists нельзя (see вердикт #1). Возвращаем в
              // OTP-под-флоу: если токен был — код мог ещё жить на сервере,
              // даём ввести его заново без повторного «получить код»
              // ('sent'); если токена не было вовсе (защитная ветка,
              // сабмит теоретически не должен был пройти гейт canSubmit) —
              // полный сброс в 'idle'.
              this.verificationStep = this.verificationToken ? "sent" : "idle";
              this.verificationToken = null;
              this.$notify(
                this.$t("errors.signup_email_not_verified_title"),
                this.$t("errors.signup_email_not_verified_text"),
                "error",
                5000
              );
            } else if (error.response && error.response?.status == 422) {
              this.$notify(this.$t("errors.user_exists_title"), this.$t("errors.user_exists_text"), "error", 5000);
            } else {
              this.setError(error.message, this.$t("errors.registration"));
            }
          })
      } else if (
        this.email &&
        this.password &&
        this.password_confirmation &&
        this.password === this.password_confirmation &&
        this.user_name &&
        this.rental_object &&
        this.company_name &&
        (this.phone && this.phone.length > 5) &&
        this.country &&
        this.city &&
        this.agreement == false
      ) {
        this.isLoading = false;
        this.$notify(this.$t("errors.agreement_title"), this.$t("errors.agreement_text"), "error", 5000);
      } else if (
        this.email &&
        this.password &&
        this.password_confirmation &&
        this.user_name &&
        this.rental_object &&
        this.company_name &&
        (this.phone && this.phone.length > 5) &&
        this.agreement &&
        this.password != this.password_confirmation
      ) {
        this.isLoading = false;
        this.$notify(this.$t("errors.pass_not_equal_title"), this.$t("errors.pass_not_equal_text"), "error", 5000);
      } else {
        this.isLoading = false;
        this.$notify(this.$t("errors.all_fields_title"), this.$t("errors.all_fields_text"), "error", 5000);
      }
      // Проверка телефона
      if (this.phone && this.phone.length < 6) {
        this.isLoading = false;
        this.phone_error = true;
        this.phone_error_text = this.$t("errors.phone_error");
      } else {
        this.phone_error = false;
        this.phone_error_text = "";
      }
    },
    getUserInfo() {
      let self = this;
      this.axios
        .get("/me.json", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          if (response.data.active) {
            self.$store.commit("setCurrentUser", response.data);
            self.signinSuccessful();
          } else {
            self.isLoading = false;
            self.$notify(self.$t("errors.deactivation_title"), self.$t("errors.deactivation_text"), "error", 5000);
          }
          // self.$router.replace({ name: "Home" });
        })
        .catch(function (error) {
          self.$store.commit("unsetCurrentUser");
          self.isLoading = false;
          self.$notify(self.$t("errors.error"), error, "error", 5000);
          // self.$router.push({ path: `/signin` }).catch(err => {});
          console.log(error);
        });
    },
    signinSuccessful() {
      let self = this;
      this.isLoading = true;
      this.axios
        .get(`/api/v1/company`, {
          headers: {
            Authorization: self.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.demo_content = this.createDemo;
          this.$store.commit("setCompany", { company: response.data });
          this.axios
            .get(`api/v1/main_companies/${response.data.main_company_id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response_main_company) => {
              this.$store.commit("setMainCompany", response_main_company.data);
            })
            .catch((error) => {
              this.isLoading = false;
              this.setError(error, this.$t("errors.main_company_data"));
              console.log(error);
            });
        })
        .then(() => {
          self.axios
            .get(`api/v1/doc_templates/${null}`, {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            })
            .then((response_data) => {
              if (response_data.data) {
                self.$store.commit("setDocUrl", response_data.data.url);
              } else {
                let doc_link =
                  self.$i18n.locale == "ru"
                    ? "https://web.rentprog.ru/doc_example.docx"
                    : "https://web.rentprog.com/doc_example_en.docx";
                self.$store.commit("setEntityDocUrl", doc_link);
              }
            })
            .catch((error) => {
              self.isLoading = false;
              self.setError(error, self.$t("errors.docs_data"));
              console.log(error);
            });
          self.axios
            .get(`api/v1/doc_entity_templates/${null}`, {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            })
            .then((doc_entity_response) => {
              // Если есть договор, то он, если нет, то по умолчанию шаблон
              if (doc_entity_response.data) {
                self.$store.commit(
                  "setEntityDocUrl",
                  doc_entity_response.data.url
                );
              } else {
                let doc_link =
                  self.$i18n.locale == "ru"
                    ? "https://web.rentprog.ru/entity_doc_example.docx"
                    : "https://web.rentprog.com/entity_doc_example_en.docx";
                self.$store.commit("setEntityDocUrl", doc_link);
              }
            })
            .catch((error) => {
              self.isLoading = false;
              self.setError(error, self.$t("errors.docs_data"));
              console.log(error);
            });
          self.axios
            .get(`api/v1/invoice_templates`, {
              headers: {
                Authorization: self.$store.getters.getAuthToken,
              },
            })
            .then((invoice_response) => {
              // Если есть договор, то он, если нет, то по умолчанию шаблон
              if (invoice_response.data) {
                self.$store.commit("setInvoiceUrl", invoice_response.data.url);
              } else {
                self.$store.commit(
                  "setInvoiceUrl",
                  "https://web.rentprog.ru/invoice_example.docx"
                );
              }
            })
            .catch((error) => {
              self.isLoading = false;
              self.setError(error, self.$t("errors.docs_data"));
              console.log(error);
            });
        })
        .catch((error) => {
          self.isLoading = false;
          self.setError(error, self.$t("errors.company_data"));
          console.log(error);
        })
        .finally(() => {
          self.isLoading = false;
          if (this.createDemo) {
            this.showCreateDemo = true;
            setTimeout(() => {
              this.showCreateDemo = false;
              this.$store.commit("setBannerRemoveDemoContent");
              this.$router.replace({ name: "Home" });
            }, 15000);
          } else {
            this.$router.replace({ name: "Home" });
          }
        });
    },
    customCountryFilter(item, queryText, itemText) {
      if (!queryText) return true;

      const searchText = queryText.toLowerCase();

      // Поиск по английскому названию
      if (item.name && item.name.toLowerCase().includes(searchText)) {
        return true;
      }

      // Поиск по нативному названию
      if (item.native && item.native.toLowerCase().includes(searchText)) {
        return true;
      }

      // Поиск по русскому названию (если поле существует)
      if (item.russian && item.russian.toLowerCase().includes(searchText)) {
        return true;
      }

      // Поиск по полю both
      if (item.both && item.both.toLowerCase().includes(searchText)) {
        return true;
      }

      return false;
    },
    // Автоподстановка кода из выбранной страны компании — но только пока
    // человек не выбрал код сам (phoneCodeTouched).
    phoneCode() {
      if (this.phoneCodeTouched) return;
      if (this.country && this.country.code) {
        this.phone_country = this.country.code;
      }
    },

    // Склейка видимых частей в то, что уходит на сервер. Из номера выкидываем
    // всё, кроме цифр: люди пишут скобки, пробелы и дефисы, а бэкенд ждёт
    // E.164. Пустой номер даёт пустой phone, а не одинокий «+7».
    syncPhone() {
      const dial = this.phoneDialFor(this.phone_country);
      const national = (this.phone_national || "").replace(/\D/g, "");
      this.phone = dial && national ? `+${dial}${national}` : null;
    },

    phoneDialFor(iso) {
      const found = this.countries.find((c) => c.code === iso);
      return found && found.phone && found.phone[0] ? String(found.phone[0]) : null;
    },
    // FT-095: guard против race changeEmail() vs in-flight
    // request/verify-запрос (вердикт #2, Signup.vue:627) — поздний ответ не
    // должен трогать состояние, если пользователь уже сбросил под-флоу
    // (changeEmail() -> 'idle', email при этом мог не измениться) или сменил
    // email на другой, пока запрос был в полёте.
    isStaleOtpResponse(requestedEmail) {
      return this.verificationStep === "idle" || (this.email || "").trim() !== requestedEmail;
    },
    // FT-095: запросить (или переотправить) код подтверждения email.
    // Ветка cooldown (429) — это НЕ ошибка для пользователя: код уже пришёл
    // ранее, просто позволяем ввести его, не блокируя флоу повторным отказом.
    requestVerificationCode() {
      const email = (this.email || "").trim();
      if (!email) {
        this.$notify(this.$t("errors.error"), this.$t("errors.email_required"), "error", 4000);
        return;
      }
      const requestedEmail = email;
      // Первичный запрос кода стартует из 'idle' — isStaleOtpResponse() на
      // idle читал бы это как «сброшено», хотя это и есть целевой переход
      // idle -> sent. Гвард ниже применяем только к резенду (стартовал из
      // 'sent').
      const isResend = this.verificationStep !== "idle";
      this.sendingCode = true;
      // Возвращаем промис: nextStep() ждёт ответа, чтобы не листать шаг,
      // когда код не ушёл (например, сервер ответил 429).
      return this.axios({
        url: "api/v1/signup_verifications",
        baseURL: this.$store.getters.getApiUrl, // FT-018
        method: "post",
        data: { email: email, locale: this.locale },
      })
        .then(() => {
          if (isResend && this.isStaleOtpResponse(requestedEmail)) return;
          this.verificationStep = "sent";
          this.startResendCooldown();
          this.$notify(this.$t("users.code_sent_email"), "", "success", 3000);
        })
        .catch((error) => {
          if (isResend && this.isStaleOtpResponse(requestedEmail)) return;
          const status = error.response && error.response.status;
          const serverError = error.response && error.response.data && error.response.data.error;
          if (status === 429 && serverError === "cooldown") {
            this.verificationStep = "sent";
            this.startResendCooldown();
            this.$notify(this.$t("users.code_sent_email"), this.$t("errors.signup_code_already_sent"), "info", 4000);
          } else if (status === 429) {
            this.$notify(this.$t("errors.error"), this.$t("errors.signup_rate_limited"), "error", 5000);
          } else if (status === 422 && serverError) {
            const key = {
              invalid_format: "errors.signup_email_invalid_format",
              disposable: "errors.signup_email_disposable",
              no_mx: "errors.signup_email_no_mx",
            }[serverError] || "errors.otp_request_failed";
            this.$notify(this.$t("errors.error"), this.$t(key), "error", 5000);
          } else {
            this.setError(error, this.$t("errors.otp_request_failed"));
          }
        })
        .finally(() => {
          this.sendingCode = false;
        });
    },
    // FT-095: подтвердить введённый код, сохранить verification_token для signup().
    verifyCode() {
      const email = (this.email || "").trim();
      const code = (this.verificationCode || "").trim();
      if (!code) return;
      const requestedEmail = email;
      this.verifyingCode = true;
      this.verificationError = "";
      this.axios({
        url: "api/v1/signup_verifications/verify",
        baseURL: this.$store.getters.getApiUrl, // FT-018
        method: "post",
        data: { email: email, code: code },
      })
        .then((response) => {
          if (this.isStaleOtpResponse(requestedEmail)) return;
          this.verificationToken = response.data.token;
          this.verificationStep = "verified";
          this.clearResendCooldown();
          this.$notify(this.$t("users.email_verified"), "", "success", 3000);
        })
        .catch((error) => {
          if (this.isStaleOtpResponse(requestedEmail)) return;
          const status = error.response && error.response.status;
          if (status === 410) {
            this.verificationError = this.$t("errors.signup_code_expired");
          } else if (status === 422) {
            const attemptsLeft = error.response.data && error.response.data.attempts_left;
            this.verificationError = attemptsLeft > 0
              ? this.$t("errors.signup_code_invalid_attempts", { n: attemptsLeft })
              : this.$t("errors.signup_code_attempts_exhausted");
          } else if (status === 429) {
            this.verificationError = this.$t("errors.signup_rate_limited");
          } else {
            this.setError(error, this.$t("errors.otp_verification_failed"));
          }
        })
        .finally(() => {
          this.verifyingCode = false;
        });
    },
    // FT-095: «изменить email» — полный сброс под-флоу, разблокировка поля.
    changeEmail() {
      this.clearResendCooldown();
      this.verificationStep = "idle";
      this.verificationCode = null;
      this.verificationToken = null;
      this.verificationError = "";
      // Возврат на шаг 1 обязателен: поле почты живёт там, а кнопка «изменить
      // email» — на шаге 2. Без этого сброс состояния оставлял человека на
      // втором шаге без единого способа поменять адрес — тупик, которого не
      // было, пока форма была одним экраном.
      this.step = 1;
      this.stepError = "";
    },
    startResendCooldown() {
      this.clearResendCooldown();
      this.resendCooldown = 60;
      this.resendTimerId = setInterval(() => {
        this.resendCooldown -= 1;
        if (this.resendCooldown <= 0) {
          this.clearResendCooldown();
        }
      }, 1000);
    },
    clearResendCooldown() {
      if (this.resendTimerId) {
        clearInterval(this.resendTimerId);
        this.resendTimerId = null;
      }
      this.resendCooldown = 0;
    },
  },
};
</script>

<style lang="css">
.form-signup {
  width: 70%;
  max-width: 500px;
  padding: 10% 15px;
  margin: 0 auto;
}

/* v-stepper-content несёт собственные отступы поверх карточных — между
   полосой шагов и первым полем получалось ~120px пустоты, и взгляд
   проваливался. Ужимаем до одной меры ритма. */
.signup-stepper .v-stepper__content {
  padding-top: 12px;
}
</style>
